<mat-toolbar>
  <mat-toolbar-row>
    <div class="toolbar">
        <!-- <button mat-icon-button (click)="sidenavToggle()" matBadge="4" matBadgeOverlap="true"> -->
        <button mat-icon-button (click)="sidenavToggle()">
          <mat-icon>menu</mat-icon>
        </button>
        <!-- 96px copies of assets/logo.png (light) and logo_dark.png (dark), shown at 36px -->
        <a routerLink="/home" class="brand" title="Home">
          <img [src]="logoSrc" alt="Retirolez" width="36" height="36">
        </a>
        <!-- Same order as before the flex layout: theme, then settings on the far right -->
        <div class="right">
          <button mat-icon-button (click)="themeToogle()" [title]="themeLabel" [attr.aria-label]="themeLabel">
            <mat-icon>{{ themeIconName }}</mat-icon>
          </button>
          <!-- Account menu only for a signed-in user (password and TOTP) -->
          @if (signedIn) {
            <button mat-icon-button [matMenuTriggerFor]="menuSettings" class="rotate" title="Account" aria-label="Account">
              <mat-icon>settings</mat-icon>
            </button>
          }
        </div>
    </div>
  </mat-toolbar-row>
</mat-toolbar>

<mat-menu #menuSettings="matMenu">
  <button mat-menu-item routerLink="/account">
    <mat-icon>account_circle</mat-icon>
    <span>Account</span>
  </button>
  <button mat-menu-item routerLink="/videocall" disabled>
    <mat-icon>videocam</mat-icon>
    <span>Conference</span>
  </button>
  <button mat-menu-item (click)="notificationToogle()">
    <mat-icon>{{ notificationIconName }}</mat-icon>
    <span>{{ notificationLabel }}</span>
  </button>
  <button mat-menu-item routerLink="/account/settings">
    <mat-icon>tune</mat-icon>
    <span>Settings</span>
  </button>
  <button mat-menu-item (click)="logout()" [hidden]="!signedIn">
    <mat-icon>logout</mat-icon>
    <span>Logout</span>
  </button>
</mat-menu>